Ext.ns('mx.data');

mx.data.ListFieldRecord = mx.data.Record.create([{name: 'value', type: 'string'}, {name: 'text', type: 'string'}]);

mx.data.ListFieldRecord.prototype.toString = function() {
    return '{value:"' + this.get('value') + '",text:"' + this.get('text') + '"}';
};
